module.exports = __webpack_public_path__ + "media/icons/plus-white-c6a98cdb.svg";